// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-container[data-v-317c9da4]{margin-bottom:2em;text-align:left;margin-top:-14px!important}", ""]);
// Exports
module.exports = exports;
